export const ADD_USERS = "ADD_USERS";
export const ADD_CSV_BULK_USERS = "ADD_CSV_BULK_USERS";
export const GET_USER_LIST = "GET_USER_LIST";
export const USER_LIST_RESPONCE = "USER_LIST_RESPONCE";
export const EDIT_USER = "EDIT_USER";
export const EDIT_USER_STATUS = "EDIT_USER_STATUS";
export const DELETE_USER = "DELETE_USER";





// redux state update 
export const DELETE_USER_REDUX_STATE = "DELETE_USER_REDUX_STATE";
export const EDIT_USER_STATUS_REDUX_STATE = "EDIT_USER_STATUS_REDUX_STATE";
export const EDIT_USER_SIGN_STATUS_REDUX_STATE = "EDIT_USER_SIGN_STATUS_REDUX_STATE";